module.exports = __webpack_public_path__ + "static/media/moody.af64f779.jpg";